import {KeyLabel} from '../../../../shared/domain/key-label.model';
export enum AlertReportType {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY',
  DAILY_AND_HOURLY = 'DAILY_AND_HOURLY'
}

export const AlertReportTypes = Object.freeze(
  [
    Object.freeze(new KeyLabel(AlertReportType.DAILY, 'Daily')),
    Object.freeze(new KeyLabel(AlertReportType.HOURLY, 'Hourly')),
    Object.freeze(new KeyLabel(AlertReportType.DAILY_AND_HOURLY, 'Daily and hourly')),
  ]
);
